// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Image_Toolbar__ihSJ8","Fullscreen":"Image_Fullscreen__h6smw"};